import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@gasbuddy/react-components';
import _ from 'lodash';
import BrandPropType from '../../utils/prop-types/brand';
import BrandOption from './option';
import styles from './styles.css';

class BrandDropdown extends React.Component {
  static propTypes = {
    brands: PropTypes.arrayOf(BrandPropType).isRequired,
    selectedBrand: PropTypes.number,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    selectedBrand: 0,
    onChange: () => {},
  };

  constructor(props) {
    super(props);

    this.state = {
      brands: _.cloneDeep(this.props.brands),
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { brands: brandsFromProps } = this.props;
    const { brands: brandFromState } = this.state;

    if (brandsFromProps.length !== nextProps.brands.length || brandFromState.length !== nextState.brands.length) {
      return true;
    }
    return false;
  }

  handleOnChange = (e) => {
    const { onChange } = this.props;

    onChange(e);
  }

  handleSearch = (searchText) => {
    const brands = _.cloneDeep(this.props.brands);
    const searchTerm = searchText.trim().toLowerCase();

    if (searchTerm.length) {
      const matches = brands.filter(b => b.display_name.toLowerCase().indexOf(searchTerm) > -1);
      this.setState(() => ({ brands: matches }));
    } else {
      this.setState(() => ({ brands }));
    }
  };

  render = () => {
    const { selectedBrand } = this.props;
    const { brands } = this.state;

    const noBrand = {
      id: 0,
      display_name: 'None',
    };

    return (
      <Dropdown
        className={styles.brandDropdown}
        onChange={this.handleOnChange}
        options={
          [noBrand].concat(brands).map(brand => ({
            value: brand.id,
            label: (<BrandOption {...brand} />),
            searchTerm: brand.display_name,
          }))
        }
        searchable
        onSearch={this.handleSearch}
        value={selectedBrand}
        placeholder="Search for a brand"
      />
    );
  }
}

export default BrandDropdown;
